import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NewTree } from 'components/NewTree';

const NewTreePage = () => <NewTree />;


export default NewTreePage;
